import type { UseFormReturn } from 'react-hook-form';
import { useFormState } from 'react-hook-form';
import { msg } from '@gonfalon/messages/msg';
import { FieldGroup, Input, TextField } from '@launchpad-ui/components';

import { RequiredLabel } from '../../../CreateMetricModal/components/RequiredLabel';
import type { MetricForm } from '../../../CreateMetricModal/formUtils';

import styles from './UnitFormField.module.css';

interface UnitFormFieldProps {
  context: UseFormReturn<MetricForm>;
  /** Id of a label the caller renders instead, such as a row's label in the sectioned layout. */
  'aria-labelledby'?: string;
}

const FIELD_NAME = 'unit';

export const UnitFormField: React.FC<UnitFormFieldProps> = ({ context, 'aria-labelledby': labelledBy }) => {
  const { register } = context;
  const { errors } = useFormState({ control: context.control, name: FIELD_NAME });
  const value = context.watch('unit');

  return (
    <FieldGroup errorMessage={errors.unit?.message}>
      <TextField aria-labelledby={labelledBy}>
        {labelledBy === undefined && <RequiredLabel label={msg('metrics.metricForm.unitLabel')} htmlFor={FIELD_NAME} />}
        <Input
          {...register(FIELD_NAME, { required: msg('metrics.metricForm.unitRequired'), shouldUnregister: true })}
          value={value}
          placeholder={msg('metrics.metricForm.unitPlaceholder')}
          id={FIELD_NAME}
          className={styles.unitFormFieldInput}
        />
      </TextField>
    </FieldGroup>
  );
};
